import { useState, useEffect } from "react";
import { ref, get } from "firebase/database";
import { database } from "../firebase";

export interface WeddingData {
  groom: {
    name: string;
    fatherName: string;
    motherName: string;
    bankAccounts: {
      self: { bankName: string; accountNumber: string };
      father: { bankName: string; accountNumber: string };
      mother: { bankName: string; accountNumber: string };
    };
  };
  bride: {
    name: string;
    fatherName: string;
    motherName: string;
    bankAccounts: {
      self: { bankName: string; accountNumber: string };
      father: { bankName: string; accountNumber: string };
      mother: { bankName: string; accountNumber: string };
    };
  };
  venue: {
    name: string;
    address: string;
    latitude: number;
    longitude: number;
  };
  date: string;
  time: string;
  invitationMessage: string;
  directions: string;
  parallaxSubtitle: string;
}

export const useWeddingData = () => {
  const [weddingData, setWeddingData] = useState<WeddingData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWeddingData = async () => {
      try {
        const weddingRef = ref(database, "wedding/info");
        const snapshot = await get(weddingRef);

        if (snapshot.exists()) {
          const data = snapshot.val();
          console.log("Firebase data:", data); // 디버깅용
          setWeddingData(data);
        } else {
          // 기본값 설정
          setWeddingData({
            groom: {
              name: "홍길동",
              fatherName: "홍판서",
              motherName: "홍씨",
              bankAccounts: {
                self: { bankName: "신한은행", accountNumber: "110-123-456789" },
                father: {
                  bankName: "신한은행",
                  accountNumber: "110-123-456789",
                },
                mother: {
                  bankName: "신한은행",
                  accountNumber: "110-123-456789",
                },
              },
            },
            bride: {
              name: "김영희",
              fatherName: "김철수",
              motherName: "김씨",
              bankAccounts: {
                self: { bankName: "신한은행", accountNumber: "110-123-456789" },
                father: {
                  bankName: "신한은행",
                  accountNumber: "110-123-456789",
                },
                mother: {
                  bankName: "신한은행",
                  accountNumber: "110-123-456789",
                },
              },
            },
            venue: {
              name: "까사디루체",
              address: "광주광역시 서구 상무대로 123",
              latitude: 35.1875422,
              longitude: 126.9324513,
            },
            date: "2024-12-31",
            time: "12:00",
            invitationMessage:
              "서로가 마주보며 다져온 사랑을 이제 함께 한 곳을 바라보며\n서로가 마주보며 다져온 사랑을 이제 함께 한 곳을 바라보며\n서로가 마주보며 다져온 사랑을 이제 함께 한 곳을 바라보며",
            directions:
              "지하철 1호선 상무역 1번 출구에서 도보 5분\n버스 123번, 456번 하차 후 도보 3분\n주차장이 마련되어 있습니다.",
            parallaxSubtitle: "소중한 분들을 초대합니다.",
          });
        }
      } catch (err) {
        setError("데이터를 불러오는 중 오류가 발생했습니다.");
        console.error("Error fetching wedding data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWeddingData();
  }, []);

  return { weddingData, loading, error };
};
